// AWS Cognito Configuration
// You'll need to replace these with your actual Cognito User Pool details

export const AUTH_CONFIG = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_XXXXXXXXX',
      userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID || 'xxxxxxxxxxxxxxxxxxxxxxxxxx',
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      // Enable social providers only if OAuth domain is configured
      ...(process.env.REACT_APP_COGNITO_OAUTH_DOMAIN && {
        loginWith: {
          oauth: {
            domain: process.env.REACT_APP_COGNITO_OAUTH_DOMAIN,
            scopes: ['openid'],
            redirectSignIn: [process.env.REACT_APP_OAUTH_REDIRECT_SIGN_IN || `${window.location.protocol}//${window.location.host}`],
            redirectSignOut: [process.env.REACT_APP_OAUTH_REDIRECT_SIGN_OUT || `${window.location.protocol}//${window.location.host}`],
            responseType: 'code',
            providers: ['LabbAzure'] // This matches the provider name you configured in Cognito
          }
        }
      })
    }
  }
};

// FastAPI backend configuration
export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
  websocketURL: process.env.REACT_APP_WEBSOCKET_URL || 'ws://localhost:8000/ws',
  
  // JWT token configuration
  jwt: {
    headerName: 'Authorization',
    tokenPrefix: 'Bearer ',
    storageKey: 'cognito_jwt_token'
  }
};

// Azure IDP configuration helper
export const AZURE_IDP_CONFIG = {
  providerName: 'LabbAzure', // This should match your Cognito IDP name
  displayName: 'Microsoft Azure AD',
  icon: 'microsoft', // For icon selection
  color: '#0078d4', // Microsoft blue
  clientId: process.env.REACT_APP_COGNITO_SAML_CLIENT_ID // SAML-specific client
};

// Environment validation
export const validateAuthConfig = () => {
  // Check if auth should be skipped in development
  if (process.env.REACT_APP_SKIP_AUTH === 'true') {
    if (process.env.REACT_APP_VERBOSE_LOGS === 'true') {
      console.log('Authentication skipped in development mode');
    }
    return false;
  }
  
  const required = [
    'REACT_APP_COGNITO_USER_POOL_ID',
    'REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID'
  ];
  
  const missing = required.filter(key => !process.env[key] || process.env[key] === 'placeholder_client_id' || process.env[key] === 'us-east-1_PLACEHOLDER');
  
  if (missing.length > 0) {
    console.warn('Missing or placeholder environment variables:', missing);
    console.warn('Please update your .env file with your actual AWS Cognito configuration');
    console.warn('Or set REACT_APP_SKIP_AUTH=true for development without authentication');
    return false;
  }
  
  return true;
};

// Check if OAuth/Social sign-in is enabled
export const isOAuthEnabled = () => {
  const enabled = !!(process.env.REACT_APP_COGNITO_OAUTH_DOMAIN && 
           process.env.REACT_APP_COGNITO_USER_POOL_ID && 
           process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID);
  
  if (enabled && process.env.REACT_APP_VERBOSE_LOGS === 'true') {
    console.log('OAuth is enabled for domain:', process.env.REACT_APP_COGNITO_OAUTH_DOMAIN);
  }
  
  return enabled;
};
